import type { KostDataImportDatasetInputProcessorProgressHandler } from './input-processor-progress';
import type { KostDataImportDatasetInputProcessorResult } from './input-processor-result';

export abstract class KostDataImportDatasetInputProcessor {
  protected constructor(
    public progressHandler: KostDataImportDatasetInputProcessorProgressHandler,
  ) {}

  public abstract process(
    inputFile: File,
    parameters?: {
      data?: { [parameter: string]: unknown };
      anonymization: { [parameter: string]: unknown };
    },
    dependencies?: {
      [dependencyId: string]: unknown;
    },
  ): Promise<KostDataImportDatasetInputProcessorResult>;
}
